<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Benefit in Kind Questionnaire</h1>
    <p>During your pre-engagement questionnaire you indicated that you have a requirement to operate payrolled benefit in kind.</p>
    <p>Please complete the following questionnaire to provide us with the information we need to set up your benefits.</p>
  </div>


</template>


<script setup>

import { ref } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object,
  clientInvite: Object
})


const validateStep = () => {
  return true;
}



const executeStep = async () => {
  return true;
}


defineExpose({ validateStep, executeStep });

</script>